// Module
var code = `<section role="alert" aria-live><span translate="modal-session-editor_single-attempt-upload-not-allowed"></span></section>`;
// Exports
export default code;